import { Dispatch, FunctionComponent, memo, RefObject, SetStateAction } from 'react';

import styles from '../custom-select.module.css';

import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import Text from '@ui/text/text/text';

type Props = {
  idx: number;
  option: TReactSelectOption;
  handlePreventDefaultClick: (e: React.MouseEvent<HTMLElement>) => void;
  setSelectedOptions: Dispatch<SetStateAction<TReactSelectOption[]>>;
  selectRef: RefObject<HTMLDivElement | null>;
  RenderMenuOptionContent?: FunctionComponent<{ option: TReactSelectOption; idx: number }>;
};

const CustomSelectMenuOption = memo(
  ({ idx, option, handlePreventDefaultClick, setSelectedOptions, selectRef, RenderMenuOptionContent }: Props) => {
    return (
      <div
        key={option.value}
        role="menuitem"
        aria-label={option.label}
        className={styles.menuOption}
        onClick={(e) => {
          handlePreventDefaultClick(e);
          setSelectedOptions((prev) => [...prev, option]);

          // let options append and then scroll
          setTimeout(() => {
            selectRef?.current?.scrollTo({
              left: selectRef?.current?.scrollWidth,
              behavior: 'smooth',
            });
          }, 0);
        }}
        data-menu-list-option
        data-menu-list-option-active="false"
        data-menu-list-option-idx={idx}
        data-menu-list-option-value={option.value}
      >
        {RenderMenuOptionContent ? (
          <RenderMenuOptionContent option={option} idx={idx} />
        ) : (
          <Text clamp={1} wordBreak="break-all">
            {option.label}
          </Text>
        )}
      </div>
    );
  }
);

CustomSelectMenuOption.displayName = 'CustomSelectMenuOption';

export default CustomSelectMenuOption;
